 
import Head from "next/head";
import { useEffect } from "react";
 
const OpenWrapScript = () => {
  
  useEffect(() => {
    

    var PWT = {};

    window.PWT = PWT;
    // Function to load a script dynamically
    const loadScript = (id, src) => {
      if (!document.getElementById(id)) {
        const script = document.createElement("script");
        script.defer = true;
        script.id = id;
        script.src = src;
        document.head.appendChild(script);
      } else {
        console.log(`${id} already loaded`);
      }
    };
 
    // Load OpenWrap script with dynamic profile version
    const loadPwt = () => {
      const purl = window.location.href;
      const baseUrl = "//ads.pubmatic.com/AdServer/js/pwt/156066/13586";
      let profileVersionId = "";
 
      if (purl.includes("pwtv=")) {
        const match = /pwtv=(.*?)(&|$)/.exec(purl);
        if (match && match[1]) {
          profileVersionId = `/${match[1]}`;
        }
      }
 
      loadScript("pwt_js", `${baseUrl}${profileVersionId}/pwt.js`);
    };
 
    // Load GPT script
    const loadGpt = () => {
      const useSSL = document.location.protocol === "https:";
      loadScript(
        "gpt_js",
        `${useSSL ? "https:" : "http:"}//securepubads.g.doubleclick.net/tag/js/gpt.js`
      );
    };
 
    // Delay the loading of PWT and GPT scripts
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadPwt);
      requestIdleCallback(loadGpt);
    } else {
      setTimeout(loadPwt, 1000);
      setTimeout(loadGpt, 1000);
    }

    return () => {
      const pwt = document.getElementById("pwt_js");
      const gpt = document.getElementById("gpt_js");
      if (pwt) pwt.remove();
      if (gpt) gpt.remove();
    };
  }, []);
  return (
    <Head>
       
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
      function initAdserver(forced) {
        if (
          (forced === true && window.initAdserverFlag !== true) ||
          (PWT.TAM_BidsReceived && PWT.ow_BidsReceived)
        ) {
          window.initAdserverFlag = true;
          PWT.TAM_BidsReceived = PWT.ow_BidsReceived = false;
          
          setTimeout(() => {
            if (window.googletag) {
              googletag.cmd.push(() => {
                if(window.location.href.includes("/ipl")||window.location.href.includes("/education/board-results") ||window.location.href.includes("/elections/assembly-chunav/bihar/") ||window.location.href.includes("/elections/faqs")
                ||window.location.href.includes("/sports/asia-cup-2025")){
                  googletag.pubads().refresh();
                }else{
                const allSlots = googletag.pubads().getSlots();
const interstitialPaths = [
  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
  "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
];
                // Exclude ATF Ads
                const slotsToRefresh = allSlots.filter(slot => 
                   !interstitialPaths.includes(slot.getAdUnitPath()) &&
                  slot.getAdUnitPath() !== "/1007232/News_tak_Desktop_HP_ATF_728x90" &&
                  slot.getAdUnitPath() !== "/1007232/News_tak_Desktop_HP_ATF_300x250" &&
                 slot.getAdUnitPath() !==  "/1007232/News_tak_Mobile_HP_ATF_300x250" &&
                  slot.getAdUnitPath() !== "/1007232/News_tak_Mobile_HP_Bottom_320x50" &&
                 slot.getAdUnitPath() !==  "/1007232/News_tak_Desktop_ROS_ATF_728x90" &&
                  slot.getAdUnitPath() !== "/1007232/News_tak_Desktop_ROS_ATF_300x250" &&
                   slot.getAdUnitPath() !== "/1007232/News_tak_Mobile_ROS_Bottom_320x50" &&
                   slot.getAdUnitPath() !== "/1007232/News_tak_Mobile_ROS_ATF_300x250" 
                );

                if(!window.ATFRefresh){
                 googletag.pubads().refresh();
                 window.ATFRefresh = true;
                }
              if (
  slotsToRefresh.length > 0 &&
  !slotsToRefresh.some(slot => interstitialPaths.includes(slot.getAdUnitPath()))
) {
  googletag.pubads().refresh(slotsToRefresh);
}

}
              });
            }
          }, 1000);
        }
      }
    `,
        }}
      ></script>
    </Head>
  );
};

export default OpenWrapScript;
